var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrehospitalMedicine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED1C24",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M21.962,10.995v-0.701 c0-0.311-0.273-0.563-0.61-0.563h-0.14c-0.337,0-0.61,0.252-0.61,0.563v0.701H21.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M2.955,7.075l0.047,15.062h2.88 c0.018-1.645,1.394-3.011,3.041-3.011s3.024,1.366,3.041,3.011h6.927V7.075H2.955z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M23.813,10.958h-4.687V22.09h1.49 c0-0.005-0.001-0.011-0.001-0.016c0-1.658,1.383-3.042,3.041-3.042c1.659,0,3.042,1.384,3.042,3.042c0,0.005,0,0.011,0,0.016 h2.833v-5.601L23.813,10.958z M26.602,16.419h-6.093v-4.336l2.773,0.039l3.319,3.155V16.419z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#231F20",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 8.904,
    cy: 22.156,
    r: 2.268
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 8.875,
    cy: 22.156,
    r: 1.218
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#231F20",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 23.685,
    cy: 22.156,
    r: 2.268
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 23.657,
    cy: 22.156,
    r: 1.218
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.955,
    y: 17.496,
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 15.925,
    height: 1.031
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.126,
    y: 17.496,
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 10.405,
    height: 1.031
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2C355E"
    },
    points: "13.818,11.138 12.254,11.138 12.254,9.574 10.106,9.574 10.106,11.138 8.542,11.138  8.542,13.286 10.106,13.286 10.106,14.85 12.254,14.85 12.254,13.286 13.818,13.286  "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrehospitalMedicine);
export default __webpack_public_path__ + "static/media/prehospital_medicine.ed44ffc14cd2aed956684445b6ab1890.svg";
export { ForwardRef as ReactComponent };